import $http from '@Config/axios';

const prefix = 'demand_region';

export const DemandRegionPresenter = {
	getAll: () => $http.get(`${prefix}/list`)
};
